"use strict";
/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */
var xtend = require("xtend");

module.exports = function (config, get, post) {
	return {
		calls: calls,
		logs: logs,
		report: report,
		controlToken: handle_control_token,
		search: {
			users: search_users
		},
		user: {
			app: {
				lock: app_lock_user,
				unlock: app_unlock_user,
				settings: app_open_android_settings
			},
			data: user_data,
			update: {
				data: handle_user_update_data,
				userType: handle_user_update_userType,
				customProperties: handle_user_update_customProperties
			},
			destory: handle_user_destory,
			resetPassword: handle_reset_password,
			testmode:{
				enable: handle_testmode_enable,
				disable: handle_testmode_disable
			}
		},
		org: {
			all: list_all_orgs,
			list: list_orgs,
			create: create_org,
			update: update_org,
			data: org_data,
			administrator: {
				set: set_org_administrator
			},
			featureFlags: (organization, flags) => {
				return post("/v2/admin/org/feature/flags", {
					organization,
					flags
				});
			},
			logistics: {
				setLogisticsOrg: setLogisticsOrg,
				assignLogisticsOrg: assignLogisticsOrg,
				getLogisticsOrgs: getLogisticsOrgs
			}
		},
		machine: {
			list: list_machines,
			fromPeople: list_machines_from_people
		},
		device: {
			list: list_devices,
			fromMacs: list_devices_from_macs
		},
		forms: {
			list: handle_admin_form_list,
			create: handle_admin_form_create,
			update: handle_admin_form_update,
			remove: handle_admin_form_remove,
			duplicate: handleAdminFormDuplicate
		},
		workflow: {
			list: handle_admin_workflow_list,
			create: handle_admin_workflow_create,
			update: handle_admin_workflow_update,
			remove: handle_admin_workflow_remove,
			duplicate: handle_admin_workflow_duplicate,
			ongoing: handle_admin_workflow_ongoing,
			definition: handle_admin_workflow_definition
		},
		resources: {
			list: handle_admin_resource_list,
			create: handle_admin_resource_create,
			update: handle_admin_resource_update,
			remove: handle_admin_resource_remove,
			duplicate: handleAdminResourceDuplicate
		},
		code: {
			list: handle_promo_code_list,
			create: handle_promo_code_create,
			remove: handle_promo_code_remove
		},
		orgGroup: {
			list: handle_orggroups_list,
			settings: {
				get: handle_orggroup_settings_get,
				set: handle_orggroup_settings_set
			},
			data: handle_orggroup_data,
			customProperties: handle_get_custom_properties,
			updateCustomProperties: handleOrgGroupUpdateCustomProperties
		},
		stats: {
			group: {
				patientCount: handle_orggroup_patient_count,
				inactiveCount: handle_orggroup_inactive_count,
				activeCount: handle_orggroup_active_count,
				staffCount: handle_orggroup_staff_count,
				userCount: handle_orggroup_user_count,
			},
			org: {
				groupCount: handle_org_orggroup_count,
				patientCount: handle_org_patient_count,
				inactiveCount: handle_org_inactive_count,
				activeCount: handle_org_active_count,
				staffCount: handle_org_staff_count,
				managersCount: handle_org_managers_count,
				userCount: handle_org_user_count,
			}
		},
		options: {
			addOption: handle_add_option,
			removeOption: handle_remove_option,
			searchOption: handle_search_options,
			schema: {
				list: handle_list_schema,
				create: handle_create_schema,
				update: handle_update_schema,
				remove: handle_remove_schema,
				duplicate: handle_duplicate_schema
			}
		},
		tables: {
			list: handle_table_list_org,
			create: handle_table_create,
			update: handle_table_update,
			remove: handle_table_remove
		},
		tasks: {
			run: handle_task_run,
			list: handle_tasks_list,
			remove: handle_tasks_remove,
			update: handle_tasks_update
		}
	};

	/**
	 * Gets the latest calls from users and downloads them to the user as a .csv.
	 * @param  {string} start  Start date of the report
	 * @param  {string} finish End date of the report
	 * @return {Prommise}        Resolves to a streamed file to user.
	 */
	function report(start, finish) {
		return get("/v2/admin/calls/report", {
			start: start,
			finish: finish
		});
	}

	/**
	 * Searches for users as an admin. Returns all users including hidden ones.
	 * @param  {String} query 	Query to search for users with
	 * @param {Object}	filter	At the moment, object with attribute 'type' consisting of two arrays of strings of type names: include/exclude
	 * @return {Promise}      	Resolves to array of users that match the query
	 */
	function search_users(query, filter) {

		if (filter && filter.type) {
			var includeType = filter.type.include;
			var excludeType = filter.type.exclude;
		}

		return get("/v2/admin/search/users", {
			q: query,
			includeType: includeType,
			excludeType: excludeType
		});
	}

	/**
	 * Gets the latest calls from users in the sustem. Loads 32 calls per page
	 * @param  {Number}  page The page to load. 0 by default
	 * @return {Promise}      Resolves to a list of calls
	 */
	function calls(callers, recipients, page, start, end, status) {
		if (!callers) callers = "";
		if (!recipients) recipients = "";
		if (!page) page = "";
		if (!start) start = "";
		if (!end) end = "";
		if (!status) status = "";
		return get("/v2/admin/calls", {
			page: page,
			callers: callers,
			recipients: recipients,
			start: start,
			end: end,
			status: status
		});
	}

	/**
	 * Gets the logs for a given call
	 * @param  {String}  call The call id for
	 * @return {Promise}      Resolves to a lost of call logs
	 */
	function logs(call) {
		return get("/v2/admin/calls/logs", {
			call: call
		});
	}

	function list_orgs(query, page) {
		if (!page) page = "";
		if (!query) query = "";
		return get("/v2/admin/org/list", {
			query: query,
			page: page
		});
	}

	function list_all_orgs(){
		return get("/v2/admin/org/list");
	}

	function create_org(data) {
		let createData = {};
		if(typeof data === "string"){
			createData.name = data;
		} else if (typeof data === "object"){
			createData = data;
		}

		return post("/v2/admin/org/create", createData);
	}

	function set_org_administrator(organization, who) {
		return post("/v2/admin/org/administrator/set", {
			organization: organization,
			who: who
		});
	}

	function setLogisticsOrg(organization, isLogisticsOrg) {
		return post("/v2/admin/org/logistics", {
			organization: organization,
			isLogisticsOrg: isLogisticsOrg
		});
	}

	function assignLogisticsOrg(organization, logisticsOrgs) {
		return post("/v2/admin/org/logistics/assign", {
			organization: organization,
			logisticsOrgs: logisticsOrgs
		});
	}

	function getLogisticsOrgs() {
		return get("/v2/admin/org/logistics");
	}

	function update_org(organization, data) {
		return post("/v2/admin/org/update", xtend(data, {
			organization: organization
		}));
	}

	function list_machines() {
		return get("/v2/admin/machine/list");
	}

	function list_machines_from_people(who) {
		return get("/v2/admin/machine/for", {
			who: who
		});
	}

	function list_devices() {
		return get("/v2/admin/device/list");
	}

	function list_devices_from_macs(macs) {
		return get("/v2/admin/device/list/macs", {
			macs: macs
		});
	}

	function handle_admin_form_list(org) {
		return get("/v2/admin/forms/list", {
			org: org
		});
	}

	function handle_admin_form_create(data, org) {
		var toSubmit = xtend(data, {
			org: org
		});
		return post("/v2/admin/forms/create", toSubmit);
	}

	function handle_admin_form_update(form, data, org) {
		var toSubmit = xtend(data, {
			form: form,
			org: org
		});
		return post("/v2/admin/forms/update", toSubmit);
	}

	function handle_admin_form_remove(form, org) {
		return post("/v2/admin/forms/remove", {
			form: form,
			org: org
		});
	}

	function handleAdminFormDuplicate(form, org, destination) {
		return post("/v2/admin/forms/duplicate", {
			form,
			org,
			destination
		});
	}

	function handle_admin_workflow_list(org) {
		return get("/v2/admin/workflow/list", {
			org: org
		});
	}

	function handle_admin_workflow_create(data, org) {
		var toSubmit = xtend(data, {
			org: org
		});
		return post("/v2/admin/workflow/create", toSubmit);
	}

	function handle_admin_workflow_update(workflow, data, org) {
		var toSubmit = xtend(data, {
			workflow: workflow,
			org: org
		});
		return post("/v2/admin/workflow/update", toSubmit);
	}

	function handle_admin_workflow_remove(workflow, org) {
		return post("/v2/admin/workflow/remove", {
			workflow: workflow,
			org: org
		});
	}

	function handle_admin_workflow_duplicate(workflow, org, destination) {
		return post("/v2/admin/workflow/duplicate", {
			workflow,
			org,
			destination
		});
	}

	function handle_admin_resource_create(name, data, org){
		return post("/v2/admin/resources/create", {
			org: org,
			data: data,
			name: name
		});
	}

	function handle_admin_resource_update(name, data, resource, org){
		return post("/v2/admin/resources/update", {
			org: org,
			data: data,
			name: name,
			resource: resource
		});
	}

	function handle_admin_resource_remove(resource, org){
		return post("/v2/admin/resources/remove", {
			resource: resource,
			org: org
		});
	}

	function handleAdminResourceDuplicate(resource, org, destination) {
		return post("/v2/admin/resources/duplicate", {
			resource,
			org,
			destination
		});
	}

	function handle_admin_resource_list(org){
		return get("/v2/admin/resources/list", {
			org: org
		});
	}

	function handle_orggroups_list(query, page, org){
		return get("/v2/admin/group/list", {
			query: query,
			page: page,
			org: org
		});
	}

	function handle_promo_code_list(){
		return get("/v2/admin/code/promo/list");
	}

	function handle_promo_code_create(code, group){
		return post("/v2/admin/code/promo", {
			code: code,
			orgGroup: group
		});
	}

	function handle_promo_code_remove(code){
		return post("/v2/admin/code/promo/remove", {
			code: code
		});
	}

	function handle_orggroup_settings_get(group){
		return get("/v2/admin/group/settings/get", {
			group: group
		});
	}

	function handle_orggroup_settings_set(group, settings){
		return post("/v2/admin/group/settings/set", {
			group: group,
			settings: settings
		});
	}

	function handle_orggroup_patient_count(group){
		return get("/v2/admin/group/users/count/patients", {
			group: group
		});
	}

	function handle_orggroup_inactive_count(group){
		return get("/v2/admin/group/users/count/patients/inactive", {
			group: group
		});
	}

	function handle_orggroup_active_count(group){
		return get("/v2/admin/group/users/count/patients/active", {
			group: group
		});
	}

	function handle_orggroup_staff_count(group){
		return get("/v2/admin/group/users/count/staff", {
			group: group
		});
	}

	function handle_orggroup_user_count(group){
		return get("/v2/admin/group/users/count", {
			group: group
		});
	}

	function handle_org_orggroup_count(org){
		return get("/v2/admin/group/count", {
			organization: org
		});
	}

	function handle_org_patient_count(org){
		return get("/v2/admin/org/users/count/patients", {
			organization: org
		});
	}
	function handle_org_inactive_count(org){
		return get("/v2/admin/org/users/count/patients/inactive", {
			organization: org
		});
	}
	function handle_org_active_count(org){
		return get("/v2/admin/org/users/count/patients/active", {
			organization: org
		});
	}
	function handle_org_staff_count(org){
		return get("/v2/admin/org/users/count/staff", {
			organization: org
		});
	}
	function handle_org_managers_count(org){
		return get("/v2/admin/org/users/count/managers", {
			organization: org
		});
	}
	function handle_org_user_count(org){
		return get("/v2/admin/org/users/count", {
			organization: org
		});
	}

	function handle_table_list_org(org){
		return get("/v2/admin/table/list", {
			organization: org
		});
	}

	function handle_table_create(actions, externals, schema, org){
		return post("/v2/admin/table/create", {
			actions: actions,
			externals: externals,
			schema: schema,
			organization: org
		});
	}

	function handle_table_update(actions, externals, schema, table, org){
		return post("/v2/admin/table/update", {
			actions: actions,
			externals: externals,
			schema: schema,
			table: table,
			organization: org
		});
	}

	function handle_table_remove(table, org){
		return post("/v2/admin/table/remove", {
			table: table,
			organization: org
		});
	}

	function handle_task_run(task){
		return post("/v2/admin/task/run", {
			task
		});
	}

	function handle_tasks_list(who, page){
		return get("/v2/admin/task/list", {
			who,
			page
		});
	}

	function handle_tasks_remove(task){
		return post("/v2/admin/task/remove", {
			task
		});
	}

	function handle_tasks_update(task, schedule, timezone){
		return post("/v2/admin/task/update", {
			task,
			schedule,
			timezone
		});
	}

	function handle_admin_workflow_ongoing(ongoing){
		return get("/v2/admin/workflow/ongoing", {
			ongoing
		});
	}

	function handle_admin_workflow_definition(definition){
		return get("/v2/admin/workflow/definition", {
			definition
		});
	}

	function app_lock_user(who){
		return post("/v2/admin/users/app/lock", {
			who: who
		});
	}

	function app_unlock_user(who){
		return post("/v2/admin/users/app/unlock", {
			who: who
		});
	}

	function app_open_android_settings(user){
		return post("/v2/admin/remote/settings", {
			user
		});
	}


	function user_data(ids){
		return get("/v2/admin/users/data", {
			who: ids
		});
	}

	function handle_user_update_data(userId, newUserData) {
		var toUpdate = xtend(newUserData, {
			userId
		});
		return post("/v2/admin/users/update/data", toUpdate);
	}

	function handle_user_update_userType(userId, newUserType) {
		return post("/v2/admin/users/update/userType", {
			userId,
			newUserType
		});
	}

	function handle_user_update_customProperties(userId, newCustomProperties) {
		return post("/v2/admin/users/update/customProperties", {
			userId,
			newCustomProperties
		});
	}

	function handle_user_destory(adminEmail, adminPassword, userId) {
		return post("/v2/admin/users/destroy", {
			adminEmail,
			adminPassword,
			userId
		});
	}

	function handle_reset_password(adminEmail, adminPassword, userId){
		return post("/v2/admin/users/resetPassword", {
			adminEmail,
			adminPassword,
			userId
		})
	}

	function handle_orggroup_data(id){
		return get("/v2/admin/group/data", {
			id: id
		});
	}

	function org_data(id){
		return get("/v2/admin/org/data", {
			id
		});
	}

	function handle_get_custom_properties(id){
		return get("/v2/admin/group/customProperties", {
			group: id
		});
	}

	function handleOrgGroupUpdateCustomProperties(groupId, newCustomProperties) {
		return post("/v2/admin/group/customProperties/update", {
			groupId,
			newCustomProperties
		});
	}

	function handle_testmode_enable (id){
		return post("/v2/admin/users/testmode/enable", {
			user: id
		});
	}

	function handle_testmode_disable (id){
		return post("/v2/admin/users/testmode/disable", {
			user: id
		});
	}

	function handle_add_option(schema, data, group){
		return post("/v2/admin/options/add/option", {
			schema,
			data,
			group
		});
	}

	function handle_remove_option(option, group){
		return post("/v2/admin/options/remove/option", {
			option,
			group
		});
	}

	function handle_search_options(fields, schema, search, page, group){
		return get("/v2/admin/options/search/option", {
			fields,
			schema,
			search,
			page,
			group
		});
	}

	function handle_list_schema(page, organization){
		return get("/v2/admin/options/list/schemas", {
			page,
			organization
		});
	}

	function handle_create_schema(schema, emrId, organization){
		return post("/v2/admin/options/schema/create", {
			schema,
			emrId,
			organization
		});
	}

	function handle_update_schema(schema, emrId, organization, schemaId){
		return post("/v2/admin/options/schema/update", {
			schema,
			emrId,
			organization,
			schemaId
		});
	}

	function handle_remove_schema(schemaId, organization){
		return post("/v2/admin/options/schema/remove", {
			schemaId,
			organization
		});
	}

	function handle_duplicate_schema(schemaId, source, destination){
		return post("/v2/admin/options/schema/duplicate", {
			schemaId,
			source,
			destination
		});
	}

	function handle_control_token(who){
		return post("/v2/admin/control", {
			who
		});
	}
};
